/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as React from 'react';
import * as styles from './commentSection.css';

import { mergeStyles } from '@cian/utils';
import { CommentShow } from '../CommentShow';
import { CommentFormContainer } from '../../containers/CommentFormContainer';

export interface ICommentSectionProps {
  editable?: boolean; //TODO: вернуть обязательное значение, когда будет логика
  comment?: string | null;
  entityId: number;
  isFetching: boolean;
}

export class CommentSection extends React.PureComponent<ICommentSectionProps, {}> {
  public render() {
    const { editable } = this.props;

    return (
      <div className={styles.comment_section_container}>
        <div {...mergeStyles(styles.comment_section, editable && styles.editable)}>{this.showComment()}</div>
      </div>
    );
  }

  /**
   * Если редактируем, то всегда показываем формочку.
   * Если есть комментарий, но не редактируем - только show
   * Если нет комментария - не показываем блок коммента
   */
  private showComment = () => {
    const { editable, comment, entityId, isFetching } = this.props;

    switch (true) {
      case editable:
        return <CommentFormContainer comment={comment} entityId={entityId} isFetching={isFetching} />;
      case comment && !editable:
        //tslint:disable-next-line:no-non-null-assertion - наличие коммента проверено выше
        return <CommentShow comment={comment!} entityId={entityId} />;
      case !comment:
      default:
        return null;
    }
  };
}
